import type { Lang } from '../types';

/** Strings for the manager's Guide preview (#146) and the sample-content controls (#131). */
export interface GuidePreviewText {
  previewButton: string;
  previewButtonHint: string;
  dialogTitle: string;
  bannerTitle: string;
  bannerBody: string;
  bannerDiffsLabel: string;
  bannerDiffs: string;
  close: string;
  languageLabel: string;
  sampleInsert: string;
  sampleBadge: string;
  sampleRemove: string;
  sampleHelp: string;
}

export const guidePreviewText: Record<Lang, GuidePreviewText> = {
  cs: {
    previewButton: '👁 Náhled pro hosta',
    previewButtonHint: 'Ukáže průvodce tak, jak ho uvidí host, včetně neuložených změn. Nic se neukládá ani neodesílá.',
    dialogTitle: 'Náhled průvodce',
    bannerTitle: 'Náhled pro správce',
    bannerBody: 'Zobrazuje právě upravované hodnoty, i neuložené. Nic se neukládá, neodesílá a žádný zámek se nemění.',
    bannerDiffsLabel: 'Liší se od skutečného průvodce',
    bannerDiffs: 'data pobytu jsou ukázková, kód chytrého zámku je zástupný, kód se zobrazuje bez časového omezení, předpověď počasí se nenačítá a platby/doplňkové služby se nezobrazují.',
    close: 'Zavřít náhled',
    languageLabel: 'Jazyk náhledu',
    sampleInsert: 'Vložit vzorový text',
    sampleBadge: 'VZOR – hostům se nezobrazí, dokud text neupravíte',
    sampleRemove: 'Odstranit vzor',
    sampleHelp: 'Vzorový text je jen začátek. Řádky „doplňte …“ nahraďte svými údaji.',
  },
  en: {
    previewButton: '👁 Preview as guest',
    previewButtonHint: 'Shows the guide the way a guest sees it, including unsaved changes. Nothing is saved or sent.',
    dialogTitle: 'Guide preview',
    bannerTitle: 'Manager preview',
    bannerBody: 'Shows the values you are editing right now, saved or not. Nothing is saved or sent and no lock is touched.',
    bannerDiffsLabel: 'Differs from the real guide',
    bannerDiffs: 'stay dates are demo dates, a smart-lock code is a placeholder, the code is shown without its reveal-time delay, the weather forecast is not loaded, and payment / extra-service panels are not shown.',
    close: 'Close preview',
    languageLabel: 'Preview language',
    sampleInsert: 'Insert sample text',
    sampleBadge: 'SAMPLE – guests will not see it until you edit it',
    sampleRemove: 'Remove sample',
    sampleHelp: 'The sample is only a start. Replace every "fill in …" line with your own details.',
  },
  vi: {
    previewButton: '👁 Xem trước như khách',
    previewButtonHint: 'Hiển thị hướng dẫn như khách sẽ thấy, kể cả thay đổi chưa lưu. Không lưu hay gửi gì cả.',
    dialogTitle: 'Xem trước hướng dẫn',
    bannerTitle: 'Xem trước của quản lý',
    bannerBody: 'Hiển thị các giá trị bạn đang chỉnh, dù đã lưu hay chưa. Không lưu, không gửi và không động đến khóa.',
    bannerDiffsLabel: 'Khác với hướng dẫn thật',
    bannerDiffs: 'ngày lưu trú là ngày mẫu, mã khóa thông minh chỉ là ký hiệu thay thế, mã hiện ngay không chờ giờ mở, dự báo thời tiết không được tải, và phần thanh toán / dịch vụ thêm không hiển thị.',
    close: 'Đóng xem trước',
    languageLabel: 'Ngôn ngữ xem trước',
    sampleInsert: 'Chèn văn bản mẫu',
    sampleBadge: 'MẪU – khách sẽ không thấy cho đến khi bạn chỉnh sửa',
    sampleRemove: 'Xóa mẫu',
    sampleHelp: 'Văn bản mẫu chỉ là điểm bắt đầu. Hãy thay mọi dòng "điền …" bằng thông tin của bạn.',
  },
  uk: {
    previewButton: '👁 Перегляд очима гостя',
    previewButtonHint: 'Показує путівник так, як його бачить гість, разом із незбереженими змінами. Нічого не зберігається й не надсилається.',
    dialogTitle: 'Перегляд путівника',
    bannerTitle: 'Перегляд для менеджера',
    bannerBody: 'Показує значення, які ви редагуєте зараз, збережені чи ні. Нічого не зберігається, не надсилається, замок не змінюється.',
    bannerDiffsLabel: 'Відрізняється від справжнього путівника',
    bannerDiffs: 'дати проживання демонстраційні, код розумного замка є заглушкою, код показано без очікування часу відкриття, прогноз погоди не завантажується, а оплата й додаткові послуги не показуються.',
    close: 'Закрити перегляд',
    languageLabel: 'Мова перегляду',
    sampleInsert: 'Вставити зразок тексту',
    sampleBadge: 'ЗРАЗОК – гості його не побачать, доки ви не відредагуєте',
    sampleRemove: 'Видалити зразок',
    sampleHelp: 'Зразок лише початок. Замініть кожен рядок «заповніть …» своїми даними.',
  },
};
